<ng-container *transloco="let t">
  <pxw-input-text
    name="name"
    [label]="t('endOrder.personalInfoNameLabel')"
    [placeholder]="t('endOrder.personalInfoNamePlaceholder')"
    [(ngModel)]="name"
    [required]="personalInformationFieldsRequired()"
    [pattern]="charactersAndSpacePattern"
    [displayErrors]="isFormSubmitted()"
    [messages]="{
      required: t('endOrder.personalInfoNameRequired'),
      pattern: t('endOrder.personalinformationNameLetters'),
    }"
  />

  <pxw-input-text
    name="phone"
    [label]="t('endOrder.personalInfoPhoneLabel')"
    [placeholder]="t('endOrder.personalInfoPhonePlaceholder')"
    [(ngModel)]="phone"
    [displayErrors]="isFormSubmitted()"
    inputMode="tel"
    [required]="personalInformationFieldsRequired()"
    pattern="^[0-9\+\- \(\)]+$"
    [messages]="{
      required: t('endOrder.personalInfoPhoneRequired'),
      pattern: t('endOrder.personalInfoPhoneInvalid'),
    }"
  />
</ng-container>
